import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export function urlValidator(control: AbstractControl): ValidationErrors | null {
  const isValid = Validators.pattern(
    "(((https?|http?)://)(%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@&=+$,A-Za-z0-9])+)([).!';/?:,][[:blank:|:blank:]])?$"
  );
  const errors = isValid(control);
  if (errors && errors['pattern']) {
    return {
      invalidUrl: true
    };
  }
  return null;
}

export function commercialRegisterNumberValidator(
  control: AbstractControl
): ValidationErrors | null {
  const isValid = Validators.pattern('^HR[AB][0-9]{1,6}$');
  const errors = isValid(control);

  if (errors && errors['pattern']) {
    return {
      invalidCommercialRegisterNumber: true
    };
  }
  return null;
}

export function taxIdNumberValidator(control: AbstractControl): ValidationErrors | null {
  const isValid = Validators.pattern(
    '^(AT|BE|BG|CY|CZ|DE|DK|EE|EL|ES|FI|FR|HR|HU|IE|IT|LT|LU|LV|MT|NL|PL|PT|RO|SE|SI|SK|XI)[0-9A-Z]{8,12}$'
  );
  const errors = isValid(control);

  if (errors && errors['pattern']) {
    return {
      invalidTaxationNumber: true
    };
  }
  return null;
}
